import { render, staticRenderFns } from "./ProductImport.vue?vue&type=template&id=f4d906e0&scoped=true&lang=pug&"
import script from "./ProductImport.vue?vue&type=script&lang=js&"
export * from "./ProductImport.vue?vue&type=script&lang=js&"
import style0 from "./ProductImport.vue?vue&type=style&index=0&id=f4d906e0&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d906e0",
  null
  
)

/* custom blocks */
import block0 from "./ProductImport.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports